import type { PropsWithChildren } from "react";

import { ADMIN_RIGHT } from "@/lib/rights";

import { RequireRight } from "./RequireRight";

/**
 * Gate /admin/* routes. Mirrors the server-side
 * `require_right("admin")` — `owner` accounts pass too. Wraps
 * `RequireRight`, which forces a fresh /me on mount so a tampered
 * React Query cache doesn't let a non-admin render the admin shell.
 */
export function RequireAdmin({ children }: PropsWithChildren) {
  return <RequireRight right={ADMIN_RIGHT}>{children}</RequireRight>;
}
